module.exports = __webpack_public_path__ + "img/zizhi16.f06fc837.png";